import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import useSearchParams from "@/hooks/useSearchParams";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { getCurrentPageNumber } from "@/lib/pagination";
import { Pagination, Spinner, Typography } from "@bookips/sds";
import { useRouter } from "next/router";
import { useEffect } from "react";
import useSnackbar from "src/store/useSnackbar";
import CashTransactionItem from "./CashTransactionItem";
import useGetCashTransactions from "./hooks/useGetCashTransactions";
const CASH_TRANSACTION_LIMIT = 10;
const CashTransaction = ()=>{
    var _error_response, _cashTransactions_data;
    const router = useRouter();
    const searchParams = useSearchParams();
    const currentPage = searchParams.get("page") ? Number(searchParams.get("page")) : 1;
    const { addSnackbar  } = useSnackbar();
    const { data: cashTransactions , isLoading , isError , error  } = useGetCashTransactions({
        offset: (currentPage - 1) * CASH_TRANSACTION_LIMIT,
        limit: CASH_TRANSACTION_LIMIT,
        groupByOrder: true
    });
    const is500Error = isError && (error === null || error === void 0 ? void 0 : (_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.status) === 500;
    useEffect(()=>{
        if (is500Error) {
            addSnackbar({
                message: "다시 시도해주세요.",
                variant: "error"
            });
        }
    }, [
        is500Error
    ]);
    const shouldShowPagination = (cashTransactions === null || cashTransactions === void 0 ? void 0 : cashTransactions.pagination.total) > 0;
    var _cashTransactions_pagination_total;
    const totalPages = getCurrentPageNumber({
        total: (_cashTransactions_pagination_total = cashTransactions === null || cashTransactions === void 0 ? void 0 : cashTransactions.pagination.total) !== null && _cashTransactions_pagination_total !== void 0 ? _cashTransactions_pagination_total : 0,
        limit: CASH_TRANSACTION_LIMIT,
        rowCount: 0
    });
    const onChangePaginate = (selectedPage)=>{
        mixpanelEvent("Pagination UI Clicked", {
            Position: "캐시",
            "Button Name": "".concat(selectedPage, "페이지")
        });
        router.push({
            pathname: router.pathname,
            query: {
                ...router.query,
                page: selectedPage.toString()
            }
        });
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "bg-white border border-gray-100 rounded-md rounded-t-none border-t-0 border-b-0",
                children: isLoading || is500Error ? /*#__PURE__*/ _jsx("div", {
                    className: "h-[200px] flex items-center justify-center",
                    children: /*#__PURE__*/ _jsx(Spinner, {
                        size: "lg",
                        className: "text-primary-main"
                    })
                }) : /*#__PURE__*/ _jsx(_Fragment, {
                    children: (cashTransactions === null || cashTransactions === void 0 ? void 0 : cashTransactions.pagination.total) > 0 ? cashTransactions === null || cashTransactions === void 0 ? void 0 : (_cashTransactions_data = cashTransactions.data) === null || _cashTransactions_data === void 0 ? void 0 : _cashTransactions_data.map((transaction)=>/*#__PURE__*/ _jsx(CashTransactionItem, {
                            transaction: transaction
                        }, transaction.id)) : /*#__PURE__*/ _jsx(Typography, {
                        variant: "body2",
                        className: "text-muted h-[200px] flex items-center justify-center",
                        children: "캐시 내역이 없어요."
                    })
                })
            }),
            shouldShowPagination && /*#__PURE__*/ _jsx(Pagination, {
                totalPages: totalPages,
                currentPage: currentPage,
                onPageChange: onChangePaginate,
                className: "flex items-center justify-center px-5 pt-6"
            })
        ]
    });
};
export default CashTransaction;
